<template>
  <confirmation-prompt
    id="customer-date-prompt"
    :show="show"
    :info-text="infoText"
    :confirm-button-text="i18n.t('/customertype/prompt/confirm')"
    :cancel-button-text="i18n.t('/common/cancel')"
    :disabled="!hasCustomerType"
    :title="i18n.t('/customertype/prompt/title')"
    :cancel-button-show="false"
    @confirm="confirmAction"
    @close="close"
  >
    <customer-type :show-labels="false" :is-purchase-order-page="isPurchaseOrderPage" />
  </confirmation-prompt>
</template>

<script>
import ConfirmationPrompt from '@/components/generic/presentational/molecules/confirmationPrompt/ConfirmationPrompt.vue'
import CustomerType from '@/components/generic/presentational/organisms/customerType/CustomerType.vue'
import AdditionalOrder from '@/mixins/additionalOrder.js'
import { mapState, mapGetters } from 'vuex'

export default {
  // Use CustomerTypeCheck mixin with any component using this prompt
  components: {
    CustomerType,
    ConfirmationPrompt,
  },
  mixins: [AdditionalOrder],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isPurchaseOrderPage: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'confirm'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    // Dynamic namespaces aren't supported by mapGetters
    ...mapState({
      hasCustomerTypeQuote(state, getters) {
        return getters[this.quoteNamespace + '/hasCustomerType']
      },
    }),
    ...mapGetters({
      hasCustomerTypePurchaseOrder: 'purchaseOrder/hasCustomerType',
    }),
    infoText() {
      return this.i18n.te('/customertype/prompt/infotext')
        ? this.i18n.t('/customertype/prompt/infotext')
        : null
    },
    hasCustomerType() {
      if (this.isPurchaseOrderPage) {
        return this.hasCustomerTypePurchaseOrder
      } else {
        return this.hasCustomerTypeQuote
      }
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    confirmAction() {
      this.$emit('confirm')
      this.close()
    },
  },
}
</script>

<style></style>
